import {useMutation, useQuery, useQueryClient, UseQueryResult} from "react-query";
import {getAllCentre, getOneCentre, setLittParams, setMobParameters} from "./centre.services";

export const useGetAllCentre = ():UseQueryResult<Centre[], Error>=>{
    return useQuery<Centre[], Error>(["centres"], getAllCentre, {
        staleTime:6000,
        refetchOnWindowFocus:false
    })
}

export const useGetCentreActuel = ():UseQueryResult<CentreComplet, Error>=>{
    const queryClient = useQueryClient();
    const useConnected:MeMob|undefined = queryClient.getQueryData(["user_connected_mob"])
    const idCentre = useConnected ? useConnected.idCentre : 0;
    return useQuery<CentreComplet, Error>(["centre_actuel", idCentre], ()=>getOneCentre(idCentre), {
        staleTime:60000,
        refetchOnWindowFocus:false,
        enabled:idCentre!==0
    })
}

export const useGetOneCentre = (id:number|undefined):UseQueryResult<CentreComplet, Error>=>{
    return useQuery<CentreComplet, Error>(["centre", id], ()=>getOneCentre(id ||-1), {
        staleTime:6000,
        refetchOnWindowFocus:false,
        enabled:id!==undefined && id>0
    })
}

export const useSetLitts = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{idCentre:number, litt:any})=>{
            return setLittParams(data.idCentre, data.litt);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre"]);
                queryClient.invalidateQueries(["centres"]);
            }
        }
    )
}

export const useSetMobParameters = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{idCentre:number, params:any})=>{
            return setMobParameters(data.idCentre, data.params);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre"]);
                queryClient.invalidateQueries(["centres"]);
            }
        }
    )
}